import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

class CommentVote extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions();
    this.setElements();
    this.setId();
    this.setUpEvents();
  }

  setElements() {
    this.$voteUp = this.element.find("[data-ajax-vote-up]");
    this.$voteDown = this.element.find("[data-ajax-vote-down]");
    this.$voteUpNumber = this.element.find("[data-ajax-vote-up-number]");
    this.$voteDownNumber = this.element.find("[data-ajax-vote-down-number]");
    this.sortBy = this.element
      .parents("#comments")
      .find(".sortBy")
      .find("option");
  }

  setUpEvents() {
    var self = this;

    this.$voteUp.on("click", function(e) {
      e.preventDefault();
      self.vote("up");
    });
    this.$voteDown.on("click", function(e) {
      e.preventDefault();
      self.vote("down");
    });

    $(window).on("abacus:customwidget:complete", function(evt, context) {
    });
  }

  setId() {
    this.id = this.element.attr("data-voting-id");
  }

  removeHiddenClass() {
    var hidden = this.element.parents("#comments").find(".sortBy")[0];
    $(hidden)
      .find(".hidden")
      .each(function() {
        $(this).removeClass("hidden");
      });
  }

  enableSortOptions(direction) {
    this.sortBy.each(function() {
      if (
        (direction == "up" && this.value == "liked") ||
        (direction == "down" && this.value == "disliked")
      ) {
        $(this)
          .removeClass("hidden")
          .prop("disabled", false);
      }
    });
  }

  vote(upOrDown) {
    this.sendVote(upOrDown);
    this.render(upOrDown);
  }

  sendVote(upOrDown) {
    var self = this;

    $.ajax({
      url: "/commentvote?commentcode=" + this.id + "&vote=" + upOrDown,
      success: function(status, xhr) {
        if (status == "ok" || xhr == "success") {
          self.removeHiddenClass();
          if (upOrDown == "up") {
            self.$voteDown.addClass("disabled");
            self.$voteUp.addClass("rated");
          } else {
            self.$voteUp.addClass("disabled");
            self.$voteDown.addClass("rated");
          }
        }
      }
    });
  }

  render(justVoted) {
    var voteCount = 0,
      self = this;

    if (parseInt(self.$voteUpNumber.text()) == 0) {
      self.$voteUpNumber.addClass("assistive");
    } else {
      self.$voteUpNumber.removeClass("assistive");
    }

    if (parseInt(self.$voteDownNumber.text()) == 0) {
      self.$voteDownNumber.addClass("assistive");
    } else {
      self.$voteDownNumber.removeClass("assistive");
    }

    if (!justVoted) return;
    if (justVoted == "up") {
      self.$voteUpNumber.removeClass("assistive");
      voteCount = parseInt(self.$voteUpNumber[0].innerText) + 1;
      self.$voteUpNumber.text(voteCount);
      this.$voteUp.replaceWith(function() {
        return $("<span class='up rated'>" + $(this).html() + "</span>");
      });
      this.$voteDown.replaceWith(function() {
        return $("<span class='down disabled'>" + $(this).html() + "</span>");
      });
    } else {
      self.$voteDownNumber.removeClass("assistive");
      voteCount = parseInt(self.$voteDownNumber[0].innerText) + 1;
      self.$voteDownNumber.text(voteCount);
      this.$voteUp.replaceWith(function() {
        return $("<span class='up disabled'>" + $(this).html() + "</span>");
      });
      this.$voteDown.replaceWith(function() {
        return $("<span class='down rated'>" + $(this).html() + "</span>");
      });
    }
    self.enableSortOptions(justVoted);
  }
}

export { CommentVote };



// WEBPACK FOOTER //
// ./Javascript/core/classes/comments/comments.vote.class.js